import React from "react";

const Check = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <polyline
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      points="2 12 9 19 22 6"
    />
  </svg>
);

export default Check;



// WEBPACK FOOTER //
// ./src/theme/icons/Check.js